/**
 * Approach lighting type
 */
export enum ApproachLightingType {
  Approach,
  RunwayEndIdentifier,
  RunwayVisualRange,
  EndTouchdown,
  VisualGlideSlope,
  RunwayVisualValue,
  Centerline
}


/**
 * Approach lighting for takeoff/land area
 */
export class ApproachLighting {
  /**
   * The int database id that represents this lighting object
   */
  lightingId: number;

  /**
   * The database id of the associated Takeoff/Land are for this object
   */
  takeoffLandAreaId: number;

  /**
   * Type of approach lighting
   */
  type: ApproachLightingType;

  /**
   * Approach lighting description
   */
  description: string;

  /**
   * Parses approach lighting
   * @param data {any} Approach lighting data as returned by API
   * @return {ApproachLighting} Parsed approach lighting
   */
  static parse(data: any): ApproachLighting {
    return {
      lightingId: data.lightingId,
      takeoffLandAreaId: data.takeoffLandAreaId,
      type: this.parseApproachLightingType(data.lightingType),
      description: data.description
    };
  }

  /**
   * Parses approach lighting type from string
   * @param value {string} Approach lighting type as returned by API
   * @return {ApproachLightingType} Parsed approach lighting type
   */
  static parseApproachLightingType(value: string): ApproachLightingType {
    if (value != null) {
      value = value.toLowerCase();
    }
    switch (value) {
      case 'approach':
        return ApproachLightingType.Approach;
      case 'runway end identifier':
        return ApproachLightingType.RunwayEndIdentifier;
      case 'runway visual range':
        return ApproachLightingType.RunwayVisualRange;
      case 'end touchdown':
        return ApproachLightingType.EndTouchdown;
      case 'visual glide slope':
        return ApproachLightingType.VisualGlideSlope;
      case 'runway visual value':
        return ApproachLightingType.RunwayVisualValue;
      case 'centerline':
        return ApproachLightingType.Centerline;
      default:
        return null;
    }
  }

  /**
   * Formats approach lighting type for display
   */
  static formatApproachLightingType(value: ApproachLightingType): string {
    switch (value) {
      case ApproachLightingType.Approach:
        return 'Approach';
      case ApproachLightingType.RunwayEndIdentifier:
        return 'Runway end identifier';
      case ApproachLightingType.RunwayVisualRange:
        return 'Runway visual range';
      case ApproachLightingType.EndTouchdown:
        return 'End touchdown';
      case ApproachLightingType.VisualGlideSlope:
        return 'Visual glide slope';
      case ApproachLightingType.RunwayVisualValue:
        return 'Runway visual value';
      case ApproachLightingType.Centerline:
        return 'Centerline';
      default:
        return null;
    }
  }
}
